import { render } from "./DataCompany.vue?vue&type=template&id=49020b18"
import script from "./DataCompany.vue?vue&type=script&lang=js"
export * from "./DataCompany.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__